module.exports = __webpack_public_path__ + "static/team-34-2892873af1f82f90d630c241959f6c5c.jpg";